<template>
  <div class="mainview_div">
    <header class="common--header">
      <b-row class="marginTopAlignment">
        <b-col cols="2" v-on:click="backAction()"><img src="images/Back_white.svg" alt=""/></b-col>
        <b-col cols="8" class="header-title text-center">REGISTRATION</b-col>
      </b-row>
    </header>

    <b-container class="personalDetail-contentdiv">
      <b-row>
        <b-col>
          <div class="box">
            <b-form @submit="onSubmit">
              <b-container>
                <p class="add-details__title">{{ this.personalDetailTitle }}</p>
                <div class="floating-form">
                  <div class="personalDetail-floating-label">
                    <select name="Primary Language" class="personalDetail-floating-select" v-model="personalDetails.pflng">
                      <option value="" hidden>- Select -</option>
                      <option v-for="language in lookups.pflng" v-bind:key="language" :value="language" class="selectOptionStyle">{{
                        language
                      }}</option>
                    </select>
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">Primary Language</label>
                  </div>

                  <div v-if="showDob">
                    <label id="dob-label" class="dob-label"> DOB </label>
                    <label v-if="errorStatus" class="dob-error-label">Enter Valid Year</label>
                  </div>
                  <div style="margin-top: -10px; margin-bottom: 20px" v-if="showDob">
                    <select class="dob-month-form-control" v-model="monthValue" required>
                      <option v-for="selectedMonth in month" v-bind:key="selectedMonth" :value="selectedMonth">{{ selectedMonth }}</option>
                    </select>
                    <select class="dob-form-control" v-model="dateValue" required>
                      <option v-for="selectedDate in date" v-bind:key="selectedDate" :value="selectedDate">{{ selectedDate }}</option>
                    </select>
                    <input
                      class="dob-inputfield"
                      type="number"
                      maxlength="4"
                      id="yearField"
                      v-model="yearValue"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    />
                  </div>

                  <div class="personalDetail-floating-label" v-if="showGender">
                    <select name="Gender" class="personalDetail-floating-select" v-model="personalDetails.gndr">
                      <option value="" hidden>- Select -</option>
                      <option v-for="genderValue in lookups.gndr" v-bind:key="genderValue" :value="genderValue">{{ genderValue }}</option>
                    </select>
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">Gender</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <select name="Marital Status" class="personalDetail-floating-select" v-model="personalDetails.mrst">
                      <option value="" hidden>- Select -</option>
                      <option v-for="statusValue in lookups.mrst" v-bind:key="statusValue" :value="statusValue">{{ statusValue }}</option>
                    </select>
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">{{ this.maritalStatus }}</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input class="personalDetail-floating-input" type="phone" placeholder=" " v-model="personalDetails.mob" />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">Cell Phone</label>
                  </div>

                  <div class="personalDetail-floating-label" v-if="showRace">
                    <multiselect
                      class="personalDetail-form-control"
                      v-model="value"
                      placeholder="- Select -"
                      :select-label="''"
                      :hide-selected="true"
                      :options="options"
                      :multiple="true"
                    ></multiselect>
                    <span class="highlight"></span>
                    <label class="race-label-field">Race</label>
                  </div>

                  <div class="personalDetail-floating-label" v-if="showEthinicity">
                    <select name="Ethnicity" class="personalDetail-floating-select" v-model="personalDetails.ethn">
                      <option value="" hidden>- Select -</option>
                      <option v-for="ethinicityValue in lookups.ethn" v-bind:key="ethinicityValue" :value="ethinicityValue">{{
                        ethinicityValue
                      }}</option>
                    </select>
                    <span class="highlight"></span>
                    <label class="race-label-field">Ethinicity</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input class="personalDetail-floating-input" type="text" placeholder=" " v-model="personalDetails.adstr" />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">Physical Street Address</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input
                      class="personalDetail-floating-input"
                      @keyup="getZipdetails(personalDetails.adzip)"
                      type="number"
                      maxlength="5"
                      placeholder=" "
                      v-model="personalDetails.adzip"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">Zip</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input class="personalDetail-floating-input" type="text" placeholder=" " v-model="personalDetails.adcty" />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">City</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input class="personalDetail-floating-input" type="text" placeholder=" " v-model="personalDetails.adst" />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">State</label>
                  </div>

                  <div class="continue__controls">
                    <label v-if="errorTxt" class="register_errorMessageLabel" id="errorLabel"> {{ errorTxtMessage }} </label>
                    <b-button type="login" variant="">{{ this.continue }}</b-button>
                  </div>
                </div>
              </b-container>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";

import Multiselect from "vue-multiselect";
export default {
  name: "Home",
  components: {
    Multiselect,
  },
  data() {
    return {
      form: {
        doorNumber: "",
        streetAddress: "",
      },
      store: store,
      errorMessage: "",
      lookups: {},
      personalDetails: {},
      state: {},
      dob: {},
      value: [],
      options: [],
      cityoptions: ["Chennai", "Madurai"],
      stateoptions: ["TamilNadu", "Kerala"],
      dateValue: "",
      date: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      monthValue: "",
      month: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      yearValue: "",
      errorStatus: false,
      showDob: false,
      showEthinicity: false,
      showRace: false,
      showGender: false,
      errorTxt: false,
      errorTxtMessage: "",
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();

      if (this.yearValue.length == 4) {
        var currentYear = new Date().getFullYear();
        if (this.yearValue >= 1900 && this.yearValue <= currentYear) {
          if (this.personalDetails.mob.length == 0) {
            this.errorTxt = true;
            this.errorTxtMessage = "Cell number cannot be empty";
          } else if (this.personalDetails.mob.length < 11) {
            this.errorTxt = true;
            this.errorTxtMessage = "Cell number is not valid";
          } else {
            this.errorTxt = false;
            this.errorStatus = false;
            this.personalDetails.dob = this.monthValue.concat("/", this.dateValue, "/", this.yearValue);
            this.personalDetails.rce = this.value;
            if (navigator.onLine) {
            var header = {};
            //   headers: [
            //     {
            //       key: "Content-Type",
            //       value: "application/json",
            //       type: "text",
            //     },
            //   ],
            // };

            apiCall
              .apiServiceCall("Post", "", "/user/", this.personalDetails, header)
              .then(response => {
                  if (response.data.status == 1) {
                    this.store.userDetails = this.personalDetails;
                    this.$router.push({ path: "/pre-medical-details" });
                  } else {
                    this.errorTxt = true;
                    this.errorTxtMessage = response.data.message;
                  }
              })
              .catch(error => {
                if (error.response.status == 500) {
                  this.errorTxt = true;
                  this.errorTxtMessage = this.serverProblem;
                } else if (error.response.status == 401) {
                  setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                } else if (error.response.status == 504) {
                  this.signout();
                }  else {
                  this.errorTxt = true;
                  this.errorTxtMessage = error.response.data.message;
                }
              });

            } else {
              this.errorTxt = true;
              this.errorTxtMessage = this.checkInternetConnection;
            }
          }
        } else {
          this.errorStatus = true;
          document.getElementById("yearField").focus();
        }
      } else {
        this.errorStatus = true;
        document.getElementById("yearField").focus();
      }
    },
    backAction() {
      this.$router.push({ path: "/set_password" });
    },
    getZipdetails(zipcode) {
      if (zipcode.length >= 5) {
        if (navigator.onLine) {
        var header = {};// [];
        apiCall
          .apiServiceCall("GetOne", "", "/lookup/zip/" + zipcode, "", header)
          .then(response => {
              if (response.data.status == 1) {
                this.personalDetails.adcty = response.data.data.cty;
                this.personalDetails.adst = response.data.data.st;
              } else {
                this.errorTxt = true;
                this.errorTxtMessage = response.data.message;
              }
          })
          .catch(error => {
            if (error.response.status == 500) {
              this.errorTxt = true;
              this.errorTxtMessage = this.serverProblem;
            } else if (error.response.status == 401) {
              setTimeout(() => this.$router.push({ path: "/home" }), 2000);
            } else if (error.response.status == 504) {
              this.signout();
            }  else {
              this.errorTxt = true;
              this.errorTxtMessage = error.response.data.message;
            }
          });

        } else {
          this.errorTxt = true;
          this.errorTxtMessage = this.checkInternetConnection;
        }
      }
    },
  },
  mounted() {
    if (navigator.onLine) {
    //Api call to fetch the dropdown list
    apiCall
      .apiServiceCall("Get", "", "/lookup/", "", "")
      .then(response => {
          if (response.data.status == 1) {
            //Setting respective values to the dropdown
            this.lookups = response.data.data;
            this.options = response.data.data.rce;

            //Api call to fetch personal details ACS12345687
            apiCall
              .apiServiceCall("GetOne", store.registration.iid, "/user/", "", "")
              .then(response => {
                  if (response.data.status == 1) {
                    this.personalDetails = response.data.data;
                    this.value = response.data.data.rce;

                    if (response.data.data.dob !== null) {
                      this.yearValue = response.data.data.dob.substring(0, 4);
                      this.monthValue = response.data.data.dob.substring(5, 7);
                      this.dateValue = response.data.data.dob.substring(8, 10);
                      this.showDob = false;
                    } else {
                      this.showDob = true;
                    }
                    if (response.data.data.rce.length <= 0 || response.data.data.rce[0].length == 0) {
                      this.showRace = true;
                    }
                    if (response.data.data.gndr == "") {
                      this.showGender = true;
                    }
                    if (response.data.data.ethn == undefined) {
                      this.showEthinicity = true;
                    }
                    if (response.data.data.ethn.length <= 0) {
                      this.showEthinicity = true;
                    }
                  } else {
                    this.errorTxt = true;
                    this.errorTxtMessage = response.data.message;
                  }
              })
              .catch(error => {
                if (error.response.status == 500) {
                  this.errorTxt = true;
                  this.errorTxtMessage = this.serverProblem;
                } else if (error.response.status == 401) {
                  setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                } else if (error.response.status == 504) {
                  this.signout();
                }  else {
                  this.errorTxt = true;
                  this.errorTxtMessage = error.response.data.message;
                }
              });

            } else {
              this.errorTxt = true;
              this.errorTxtMessage = response.data.message;
            }
        })
        .catch(error => {
 if (error.response.status == 500) {
          this.errorTxt = true;
          this.errorTxtMessage = this.serverProblem;
        } else if (error.response.status == 401) {
          setTimeout(() => this.$router.push({ path: "/home" }), 2000);
        } else if (error.response.status == 504) {
            this.signout();
        }  else {
          this.errorTxt = true;
          this.errorTxtMessage = error.response.data.message;
        }
      });

    } else {
      this.errorTxt = true;
      this.errorTxtMessage = this.checkInternetConnection;
    }
  },
};
</script>
